import React, { useCallback, useEffect, useRef, useState } from "react";
import Breadcrump from "../../components/Breadcrump";
import categoryAPI from "../../api/categoryApi";
import CategoryCard from "../categories/Card";
import Categoriespage from "./Categoriespage";

function ListPage() {
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const observer = useRef();

  const fetchCategories = async (currentPage) => {
    setLoading(true);

    try {
      const res = await categoryAPI.listing({
        page: currentPage,
      });

      if (res.code === 200) {
        const { items, totalCount } = res.data;

        setItems((prev) => [...prev, ...(items || [])]);
        setTotalCount(totalCount);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories(page);
  }, [page]);

  // 🔥 Intersection Observer
  const lastItemRef = useCallback(
    (node) => {
      if (loading) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && items.length < totalCount) {
          setPage((prev) => prev + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, items, totalCount],
  );

  return (
    <>
      <Breadcrump title="Category" />
      <section className="treatments-v3 py-5">
        <div className="container">
          <div className="section-head-v3 mb-5">
            <h2>What We Treat</h2>
            Total: <b>{totalCount}</b> categories
          </div>

          <div className="row g-4">
            {items.map((item, index) => {
              const isLast = items.length === index + 1;

              return (
                <div
                  ref={isLast ? lastItemRef : null}
                  className="col-lg-4 col-md-6 col-sm-12 mb-4"
                  key={item._id || index}
                >
                  <Categoriespage item={item} />
                </div>
              );
            })}
          </div>

          {/* 🔥 Loader */}
          {loading && (
            <div className="text-center mt-4">
              <p>Loading more products...</p>
            </div>
          )}

          {/* End Message */}
          {!loading && items.length >= totalCount && (
            <div className="text-center mt-4">
              <p>✨ You’ve reached the end</p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default ListPage;
